import type { Building } from "building-types/building/buildingTypes";
import { collectWallCuts } from "../elements/walls/wallCut";
import memo from "../utils/memo";

function select({ levels, doorPlacements: doors, windowPlacements: windows, wallCuts, wallMasses }: Building) {
  return {
    levels,
    doors,
    windows,
    wallCuts,
    wallMasses,
  };
}

function generate({ levels, doors, windows, wallCuts: w, wallMasses }: ReturnType<typeof select>): {
  wallCuts: Building["wallCuts"];
} {
  const allWallCuts = collectWallCuts({
    levels,
    doors,
    windows,
    wallCuts: w,
    wallMasses,
  });

  return { wallCuts: allWallCuts };
}

export default memo(select, generate);
